import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ChapterType, IChapter } from '../../../models/admin';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-chapter-card',
  templateUrl: './chapter-card.component.html',
  styleUrls: ['./chapter-card.component.scss'],
  standalone: false
})
export class ChapterCardComponent {
  @Input('chapter') chapter!: IChapter;
  @Input('isLoading') isLoading!: boolean;
  @Input('canEdit') canEdit: boolean = false;
  @Input("canDelete") canDelete: boolean = false;
  @Output() edit = new EventEmitter<IChapter>();
  @Output() delete = new EventEmitter<IChapter>();
  @Output() click = new EventEmitter<IChapter>();

  isHovered = false;
  showConfirmDialog = false;
  chapterName: string = "";

  constructor(private dialog: MatDialog) { }

  getChapterTypeDisplay(type: ChapterType): { title: string, className: string, name: string } {
    let shortType: string;
    let fullType: string
    switch (type) {
      case ChapterType.Book:
        shortType = 'B';
        fullType = 'Book';
        break;
      case ChapterType.Preface:
        shortType = 'P';
        fullType = 'Preface';
        break;
      case ChapterType.Chat:
        shortType = 'C';
        fullType = 'Chat';
        break;
      case ChapterType.Story1:
        shortType = 'S1';
        fullType = 'Story 1';
        break;
      case ChapterType.Story2:
        shortType = 'S2';
        fullType = 'Story 2';
        break;
      case ChapterType.Story3:
        shortType = 'S3';
        fullType = 'Story 3';
        break;
      case ChapterType.Story4:
        shortType = 'S4';
        fullType = 'Story 4';
        break;
      case ChapterType.VisualSeries1:
        shortType = 'V1';
        fullType = 'Visual Series 1';
        break;
      case ChapterType.VisualSeries2:
        shortType = 'V2';
        fullType = 'Visual Series 2';
        break;
      case ChapterType.VisualSeries3:
        shortType = 'V3';
        fullType = 'Visual Series 3';
        break;
      case ChapterType.VisualSeries4:
        shortType = 'V4';
        fullType = 'Visual Series 4';
        break;
      case ChapterType.VisualSeries5:
        shortType = 'V5';
        fullType = 'Visual Series 5';
        break;
      case ChapterType.Topic1:
        shortType = 'T1';
        fullType = 'Topic 1';
        break;
      case ChapterType.Topic2:
        shortType = 'T2';
        fullType = 'Topic 2';
        break;
      case ChapterType.Topic3:
        shortType = 'T3';
        fullType = 'Topic 3';
        break;
      case ChapterType.Topic4:
        shortType = 'T4';
        fullType = 'Topic 4';
        break;
      case ChapterType.Topic5:
        shortType = 'T5';
        fullType = 'Topic 5';
        break;
      default:
        shortType = 'U';
        fullType = 'Unknown';
    }
    return {
      title: `Chapter Type: ${fullType}`,
      className: `chapter-type-${shortType.toLowerCase()}`,
      name: fullType
    };
  }

  onEdit(event: Event, chapter: IChapter) {
    event.stopPropagation();
    this.edit.emit(chapter);
  }

  onDelete(event: MouseEvent, chapter: IChapter) {
    event.stopPropagation();
    event.preventDefault();

    const dialogRef = this.dialog.open(ConfirmDeleteChapterDialogComponent, {
      width: '300px',
      data: { chapterTitle: chapter.Title }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete.emit(chapter);
      }
    });
  }

  onCardClick(event: Event, chapter: IChapter) {
    event.stopPropagation();
    this.click.emit(chapter);
  }

  showChapterStatusIcon(status: string) {
    return this.chapter.Status === status;

  }
}

@Component({
  selector: 'app-confirm-delete-chapter-dialog',
  standalone: true,
  template: `
    <h2 mat-dialog-title class="warning-title">
      <mat-icon color="warn" class="warning-icon">warning</mat-icon>
      Delete Chapter
    </h2>

    <mat-dialog-content class="warning-content">
      Are you sure you want to delete <b>{{data.chapterTitle}}</b>?
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close cdkFocusInitial>No</button>
      <button mat-button color="warn" (click)="onConfirm()">Yes</button>
    </mat-dialog-actions>
  `,
  styles: [`

    .warning-title {
      display: flex;
      align-items: center;
      color: #d32f2f;
      font-weight: 500;
      margin: 0;
    }

    .warning-icon {
      font-size: 24px;
      line-height: 1;
      vertical-align: middle;
    }

    .warning-content {
      margin-top: 8px;
    }
  `],
  imports: [
    MatDialogModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatIconModule
  ]
})
export class ConfirmDeleteChapterDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteChapterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { chapterTitle: string }
  ) { }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
